import React from "react";
import "./../styles/Hero.css";
import heroImg from "../assets/Profile.png";
import { FaLinkedin, FaGithub, FaAward } from "react-icons/fa";

export default function Hero() {
  return (
    <section id="home" className="hero">
      {/* BACKGROUND EFFECTS */}
      <div className="bg-blob one"></div>
      <div className="bg-blob two"></div>

      {/* STARS */}
      <div className="stars"></div>
      <div className="stars stars2"></div>
      <div className="stars stars3"></div>

      <div className="hero-content">
        {/* LEFT CONTENT */}
        <div className="hero-left">
          <h1 className="hero-title">
            Hello, I’m{" "}
            <span className="hero-name animated-gradient">
              Abikrishna
            </span>
          </h1>

          <h2 className="hero-role">
            Business Analyst & UI/UX Engineer
          </h2>

          <p>
            I analyze business needs and design user-centric digital
            solutions using research, usability, and data-driven
            decision making.
          </p>

          {/* SKILLS */}
          <div className="skill-tags">
            <span>Business Analysis</span>
            <span>UI Design</span>
            <span>Front End</span>
          </div>

          {/* BUTTONS */}
          <div className="hero-buttons">
            <a href="#contact" className="btn-hire">
              Hire Me
            </a>
            <a href="#projects" className="btn-projects">
              View Projects
            </a>
          </div>

          {/* SOCIAL ICONS */}
          <div className="hero-socials">
            <a
              href="https://www.linkedin.com/in/abikrishna-sivananthan"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://github.com/abikrishnas99"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaGithub />
            </a>
          </div>

          {/* EXPERIENCE */}
          <div className="experience">
            <FaAward className="badge-icon" />
            <span>1+ Year Experience</span>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="hero-right">
          <div className="profile-frame floating">
            <img src={heroImg} alt="Abikrishna" />
          </div>
        </div>
      </div>
    </section>
  );
}
